module.exports = __webpack_public_path__ + "img/touchid_solid.428fcc29.svg";